/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MGear, MGearInterface } from "../MGear";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IMineablePunks",
        name: "_mineablePunks",
        type: "address",
      },
      {
        internalType: "contract IMineableWords",
        name: "_mineableWords",
        type: "address",
      },
      {
        internalType: "contract IMGear",
        name: "_mgear",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "normal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "solid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "noteworthy",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hashed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
    ],
    name: "getTransmutationRarity",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "inscribed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mgearRenderer",
    outputs: [
      {
        internalType: "contract IMGear",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineablePunks",
    outputs: [
      {
        internalType: "contract IMineablePunks",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineableWords",
    outputs: [
      {
        internalType: "contract IMineableWords",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "mpunkRolls",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToDifficulties",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToUpgradeRoll",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "rename",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenIdToMGear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "transmute",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transmuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class MGear__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _mineablePunks: string,
    _mineableWords: string,
    _mgear: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MGear> {
    return super.deploy(
      _mineablePunks,
      _mineableWords,
      _mgear,
      normal,
      solid,
      noteworthy,
      overrides || {}
    ) as Promise<MGear>;
  }
  getDeployTransaction(
    _mineablePunks: string,
    _mineableWords: string,
    _mgear: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mineablePunks,
      _mineableWords,
      _mgear,
      normal,
      solid,
      noteworthy,
      overrides || {}
    );
  }
  attach(address: string): MGear {
    return super.attach(address) as MGear;
  }
  connect(signer: Signer): MGear__factory {
    return super.connect(signer) as MGear__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MGearInterface {
    return new utils.Interface(_abi) as MGearInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MGear {
    return new Contract(address, _abi, signerOrProvider) as MGear;
  }
}
